// extracted by mini-css-extract-plugin
export default {"filterTag":"styles_filterTag__FaJdl","label":"styles_label__-8MCN","darkMode":"styles_darkMode__EJsnb","value":"styles_value__kHpBH"};